import PropTypes from 'prop-types';

function IFBakeryActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11317)">
                <path
                    d="M4.62517 15.8204C3.32683 12.5039 2.95824 11.8394 2.03638 9.61215C0.955623 7.00156 1.34648 2.62113 4.83816 1.49509C7.5611 0.620127 9.84447 1.81576 11.9889 5.65139C13.8939 9.04699 15.1981 12.7728 15.9086 14.4432C16.6192 16.1136 20.5166 22.5651 19.7667 26.1554C19.237 28.7081 16.1925 30.9272 12.7038 29.1977C9.55007 27.6312 9.06868 25.7561 7.33364 22.0167C5.5986 18.2772 4.62517 15.8204 4.62517 15.8204Z"
                    fill="#F6A685"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.65925 14.1462C7.09841 13.1363 8.64981 9.43906 13.2131 10.7892C11.7141 12.5944 6.65925 14.1462 6.65925 14.1462Z"
                    fill="#F4F0F2"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.65705 18.9577C9.09131 17.9469 10.6427 14.2496 15.206 15.5997C13.7079 17.4001 8.65705 18.9577 8.65705 18.9577Z"
                    fill="#F4F0F2"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.3189 25.8026C11.7522 24.7967 13.3045 21.0945 17.8669 22.4496C16.3737 24.2509 11.3189 25.8026 11.3189 25.8026Z"
                    fill="#F4F0F2"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.93584 9.42125C4.36912 8.41537 5.92149 4.71318 10.4838 6.06821C8.99067 7.86951 3.93584 9.42125 3.93584 9.42125Z"
                    fill="#F4F0F2"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.6865 20.3961C14.5604 21.9402 16.9081 23.5474 17.9205 23.6853C18.5744 23.7798 23.3999 24.0201 25.1016 24.2407C26.8033 24.4613 27.3942 24.2643 27.4848 23.122C27.5754 21.9796 27.9693 18.1665 27.9614 17.2684C27.9536 16.3702 28.4341 16.319 28.962 15.996C29.9113 15.417 29.671 13.3095 29.1629 12.5335C28.6547 11.7575 28.0717 10.9106 25.2552 10.4221C24.0735 10.2133 22.8917 10.0873 22.3206 10.0282C20.5204 9.88638 16.4118 9.63428 16.4118 9.63428C16.2503 11.5487 14.7534 15.287 15.3876 15.8385C15.6752 16.0866 15.0331 17.4456 15.0174 17.8553C14.9767 18.7098 14.866 19.5596 14.6865 20.3961V20.3961Z"
                    fill="#F7D46D"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M28.1308 16.559C28.1308 16.559 25.1646 16.3502 20.8867 16.2557C18.8895 16.2163 19.5474 20.2972 19.7049 23.6416C20.0043 23.7716 24.1798 24.1655 25.7516 24.3073C27.3233 24.4491 27.3942 24.0709 27.5321 22.6095C27.6699 21.1481 27.6817 19.2927 28.1308 16.559Z"
                    fill="#F6A685"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.9008 19.3519C10.7787 20.9 10.0776 22.9917 11.086 23.1335C11.7399 23.228 16.2069 23.4683 17.9204 23.685C19.634 23.9016 20.213 23.7086 20.3036 22.5702C20.3942 21.4318 20.7881 17.6147 20.7763 16.7127C20.7645 15.8106 21.249 15.7673 21.7808 15.4443C22.7301 14.8652 22.4899 12.7578 21.9778 11.9778C21.4657 11.1978 20.8906 10.3588 18.0583 9.86641C16.4528 9.61044 14.8241 9.53118 13.2013 9.63006C11.4011 9.79157 9.96332 10.8118 9.84515 12.226C9.68758 14.1365 10.1406 14.3531 10.7748 14.9007C10.9101 15.0489 11.012 15.2244 11.0739 15.4153C11.1357 15.6062 11.1559 15.8082 11.1333 16.0076C11.082 17.2405 10.9008 19.3519 10.9008 19.3519Z"
                    fill="#F4F0F2"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11317">
                    <rect width="30" height="30" fill="white" transform="translate(0.545898 0.380859)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default IFBakeryActive;

IFBakeryActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

IFBakeryActive.defaultProps = {
    className: null,
    width: 28,
};
